import { render, staticRenderFns } from "./ultimScores.vue?vue&type=template&id=78171052&scoped=true&"
import script from "./ultimScores.vue?vue&type=script&lang=js&"
export * from "./ultimScores.vue?vue&type=script&lang=js&"
import style0 from "./ultimScores.vue?vue&type=style&index=0&id=78171052&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "78171052",
  null
  
)

export default component.exports